import React, { useState } from 'react'
import styles from './AccordionStyles'
import { Popup, Button } from 'semantic-ui-react'

export function Accordion(props) {
  const {
    teamName, noOfProjects, children, active, addProjectButton, onAddProject
  } = props
  const [ isOpen, setOpen  ] = useState(active || true)
  const toggleAccordion = () => setOpen(!isOpen)

  return (
    <div className={styles.accordion}>
      <div className={styles.accordionHead} onClick={toggleAccordion}>
        <div className={styles.title}>
          <div className={styles.teamName}>{teamName}</div>
          <div className={styles.noOfProjects}>{noOfProjects} Projects</div>
        </div>
        { addProjectButton &&
          <div className={styles.addButton}>
            <Popup
              content='Add Project' size='mini' inverted
              trigger={
                <Button basic icon='plus' circular size='mini'
                        onClick={onAddProject}/>
              }
            />
          </div>
        }
      </div>
      <div className={styles.accordionPanel} isopen={isOpen.toString()}>
        {children}
      </div>
    </div>
  )
}

export function AccordionItem(props) {
  const { title, noOfVideos, active, onClick } = props
  const isActiveProject = Boolean(active)

  return (
    <div className={styles.project(isActiveProject)} onClick={onClick}>
      <div className={styles.projectName}>{title}</div>
      <div className={styles.noOfVideos}>{noOfVideos} Videos</div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/Components/SideBarLeft/Accordion.js